import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Injector } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { LocationListing, LocationSummary, PalletLocationDto } from '~/models/modules/location';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({ providedIn: 'root' })
export class LocationsService extends ApiServiceBase {
  locationClosed: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  locationAdded: EventEmitter<any> = new EventEmitter();
  locationUpdated: EventEmitter<any> = new EventEmitter();

  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.stocks);
  }

  getLocation(id: number) {
    return this.http.get<LocationSummary>(this._url(`/${id}`));
  }

  getLocationListing() {
    return this.http.get<LocationListing[]>(this._url());
  }

  getPallets(paramsObj?: any) {
    let params = paramsObj ? createHttpParams(paramsObj) : undefined;
    return this.http.get<{ data: PalletLocationDto[]; returnCount: number }>(this._url(`/pallets`), { params, observe: 'response' });
  }

  getLocationsByAccounts(model: any = null) {
    return this.http.post<LocationListing[]>(this._url(`/LocationsByAccounts`), model);
  }

  getLocationsBySitesEnterprise(model: any = {}) {
    return this.http.post<LocationListing[]>(this._url(`/LocationsBySitesEnterprise`), model);
  }

  getLocationListingBySite(siteId: number) {
    return this.http.get<LocationListing[]>(this._url(`/site/${siteId}`));
  }

  getLocations(paramsObj?: any, model?: any, screenSiteId?: number) {
    paramsObj = paramsObj || {};
    paramsObj.screenSiteId = screenSiteId;
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http.post<LocationSummary[]>(this._url(`/grid-data`), model, { params, observe: 'response' }).pipe(map(augmentPaging));
  }

  getAccountLocation(accountIds: any[], paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    model['accountIds'] = accountIds;

    return this.http.post<LocationSummary[]>(this._url(`/accounts`), model, { params, observe: 'response' }).pipe(map(augmentPaging));
  }

  createLocation(model: any) {
    return this.client.post<string>(this._url(), model);
  }

  updateLocation(id: number, model: any) {
    return this.client.put(this._url(`/${id}`), model);
  }

  deleteLocation(id: number) {
    return this.client.delete(this._url(`/${id}`));
  }

  deactivateLocation(obj: any) {
    return this.client.put(this._url(`/deactivate`), obj);
  }

  deactivateLocationBatch(obj: any) {
    return this.client.put(this._url(`/batchDeactivate`), obj);
  }

  reactivateBatchLocation(obj: any) {
    return this.client.put(this._url(`/batchReactivate`), obj);
  }

  reactivateLocation(obj: any) {
    return this.client.put(this._url(`/reactivate`), obj);
  }

  getNumberofstockPerDate(id: number) {
    return this.client.get(this._url(`/stock-number-per-date/${id}`));
  }

  getNumberOfCatPerDate(id: number) {
    return this.client.get(this._url(`/category-by-date/${id}`));
  }

  GetStockItemByLocationChart(locationId: number) {
    return this.client.get(this._url(`/Locations/${locationId}/StockItemLocationChart`));
  }

  LocationFormClosed(newlocation: any) {
    this.locationClosed.next(newlocation);
  }

  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/Locations${v}`);
  }
}
